type HexCode = `${number | string}`;

type PanelThemeColors = {
  textColor: HexCode;
  borderColor: HexCode;
  backgroundColor: HexCode;
};

export const panelThemeColors: { [key: string]: PanelThemeColors } = {
  MORNING: {
    textColor: '#023850CC',
    borderColor: '#C1D2D9',
    backgroundColor: '#F1F9FB'
  },
  AFTERNOON: {
    textColor: '#023850CC',
    borderColor: '#C1D2D9',
    backgroundColor: '#F1F9FB'
  },
  EVENING: {
    textColor: '#023850CC',
    borderColor: '#C1D2D9',
    backgroundColor: '#F1F9FB'
  },
  NIGHT: {
    textColor: '#023850CC',
    borderColor: '#C1D2D9',
    backgroundColor: '#F1F9FB'
  }
};

export type PanelTheme = keyof typeof panelThemeColors;
